import styled from 'styled-components';
import { toRem } from '../../../utils/toRem';

export const SMessageTextContainer = styled.div`
  margin-top: ${toRem(8)};
  margin-left: ${toRem(6)};
`;
